import React from "react";
import { Tag } from "antd";

const statusConfig = {
  draft: { color: "default", label: "Draft" },
  sent: { color: "blue", label: "Sent" },
  viewed: { color: "cyan", label: "Viewed" },
  accepted: { color: "green", label: "Accepted" },
  rejected: { color: "red", label: "Rejected" },
  expired: { color: "orange", label: "Expired" },
  converted: { color: "purple", label: "Converted" },
  revised: { color: "gold", label: "Revised" },
};

const QuotationStatusBadge = ({ status }) => {
  const config = statusConfig[status] || { color: "default", label: status };

  return <Tag color={config.color}>{config.label}</Tag>;
};

export default QuotationStatusBadge;
